import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_URL =
  "https://etoile-bricolage-api.imanehibouzid2001.workers.dev";

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await fetch(
          `${API_URL}/api/admin/session`,
          {
            method: "GET",

            // IMPORTANT :
            // permet d'envoyer le cookie sécurisé
            credentials: "include",
          }
        );

        const data = await response.json();

        if (
          response.ok &&
          data.success &&
          data.authenticated === true
        ) {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      } catch (error) {
        console.error(
          "Erreur vérification session :",
          error
        );

        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkSession();
  }, []);

  // Pendant la vérification
  if (loading) {
    return (
      <div style={styles.page}>
        <div style={styles.box}>
          <div style={styles.spinner}></div>

          <p style={styles.text}>
            Vérification de la connexion...
          </p>
        </div>
      </div>
    );
  }

  // Pas connecté
  if (!authenticated) {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  // Connecté
  return children;
}

const styles = {
  page: {
    minHeight: "60vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f6f2",
  },

  box: {
    textAlign: "center",
  },

  spinner: {
    width: "35px",
    height: "35px",
    margin: "0 auto",
    border: "4px solid #e5e5e5",
    borderTop: "4px solid #384525",
    borderRadius: "50%",
  },

  text: {
    marginTop: "15px",
    color: "#666",
    fontSize: "14px",
  },
};

export default ProtectedRoute;